import { fetchJsonResponse } from '@/ai/api'
import { buildSingleCardPrompt } from '@/ai/prompts'

export const generateSingleCard = async ({
  eventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  cardTypeId,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleCardPrompt({
    eventId,
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    cardTypeId
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
